<template>
  <a-form
    id="my_form_styl"
    :label-col="{
      span: 12,
    }"
    :wrapper-col="{
      span: 12,
    }"
    :form="form"
  >
    <a-form-item :label="$t('Status')">
      <a-tag style="font-weight: bold" color="#FCB76F">{{
        $t(document.status)
      }}</a-tag>
    </a-form-item>

    <a-form-item :label="$t('File name')">
      <a-tooltip>
        <template slot="title">
          <span>{{ document.NAME }}</span>
        </template>
        <span>{{ document.NAME }}</span>
      </a-tooltip>
    </a-form-item>

    <a-form-item :label="$t('Document type')">
      <template v-if="disableFromResponsible || !currentEdit">
        {{ $t(document.document_type) }}
      </template>
      <template v-else>
        <span v-if="flagDoctype" @click="flagDoctype = !flagDoctype">
          {{ $t(document.document_type) }}
          <i
            class="fa fa-pencil"
            style="font-size: 14px; margin-left: 15px; color: gray"
          ></i>
        </span>
        <a-select
          v-else
          showSearch
          optionFilterProp="children"
          v-decorator="[
            'document_type',
            {
              rules: [
                {
                  required: true,
                  message: $t('Document type') + $t('required_field'),
                },
              ],
              initialValue: document.document_type,
            },
          ]"
        >
          <a-select-opt-group label="Main">
            <a-select-option value="Dokument zwykly">{{
              $t("Regular document")
            }}</a-select-option>
            <a-select-option value="Dokument poufny">{{
              $t("Сonfidential document")
            }}</a-select-option>
            <a-select-option value="FVZ">{{ $t("Invoice") }}</a-select-option>
          </a-select-opt-group>
          <a-select-opt-group v-if="bounds.whole" label="OCR">
            <a-select-option v-for="item in bounds.whole.titles" :key="item">{{
              item
            }}</a-select-option>
          </a-select-opt-group>
        </a-select>
      </template>
    </a-form-item>

    <a-form-item :label="$t('Document name')">
      <div
        v-if="disableFromResponsible || !currentEdit"
        style="white-space: nowrap; overflow: hidden"
      >
        {{ document.title }}
      </div>
      <template v-else>
        <span
          v-if="flagDocName"
          @click="flagDocName = !flagDocName"
          style="display: flex; cursor: pointer"
        >
          {{ document.title }}
          <i
            class="fa fa-pencil"
            style="font-size: 14px; margin-left: 15px; color: gray"
          ></i>
        </span>
        <a-dropdown v-else>
          <a-input
            class="ant-dropdown-link"
            v-decorator="[
              'title',
              {
                rules: [
                  {
                    required: true,
                    message: $t('Document name') + $t('required_field'),
                  },
                ],
                initialValue: document.title,
              },
            ]"
          />
          <a-menu v-if="bounds.whole" slot="overlay">
            <a-menu-item v-for="item in bounds.whole.titles" :key="item">
              <a href="javascript:;">{{ item }}</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
    </a-form-item>
    <a-form-item :label="$t('Date of issue')">
      <template v-if="disableFromResponsible || !currentEdit">
        {{ document.date_recept }}
      </template>
      <a-date-picker
        v-else
        :format="YYYY - MM - DD"
        v-decorator="[
          'date_recept',
          {
            rules: [
              {
                required: true,
                message: $t('Date of issue') + $t('required_field'),
              },
            ],
            initialValue: document.date_recept
              ? moment(document.date_recept, 'YYYY-MM-DD')
              : '',
          },
        ]"
      />
    </a-form-item>
    <a-form-item :label="$t('Document number')">
      <template v-if="disableFromResponsible || !currentEdit">
        {{ document.num_doc }}
      </template>
      <a-dropdown v-else>
        <a-input
          class="ant-dropdown-link"
          v-decorator="[
            'num_doc',
            {
              rules: [
                {
                  required: true,
                  message: $t('Document number') + $t('required_field'),
                },
              ],
              initialValue: document.num_doc,
            },
          ]"
        />
        <a-menu v-if="bounds.whole" slot="overlay">
          <a-menu-item v-for="item in bounds.whole.titles" :key="item">
            <a href="javascript:;">{{ item }}</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </a-form-item>

    <a-form-item :label="$t('main_company_n_hub')">
      <template v-if="disableFromResponsible || !currentEdit">{{
          getCompany(document.my_company)
      }}</template>
      <template v-else>
        <span v-if="flagMyCompany" @click="flagMyCompany = !flagMyCompany">
          {{
            getCompany(document.my_company)
          }}
          <i
            class="fa fa-pencil"
            style="font-size: 14px; margin-left: 15px; color: gray"
          ></i>
        </span>
        <div v-else>
          <!--<a-select
            showSearch
            optionFilterProp="children"
            v-decorator="[
              'my_company',
              {
                rules: [
                  {
                    required: true,
                    message: $t('main_company_n_hub') + $t('required_field'),
                  },
                ],
                initialValue: document.my_company,
              },
            ]"
            @change="handleMyCompanyChange"
          >
            <a-select-opt-group label="Main">
              <a-select-option v-for="(comp, id) in MY_COMPANY_LIST" :key="id"
                >{{ comp[info.UF_CRM_1579190093741] }} /
                {{ comp.TITLE }}</a-select-option
              >
            </a-select-opt-group>
            <a-select-opt-group v-if="bounds.whole" label="OCR">
              <a-select-option
                v-for="item in bounds.whole.titles"
                :key="item"
                >{{ item }}</a-select-option
              >
            </a-select-opt-group>
          </a-select>-->
          <a-input
            @change="changePromptStatus"
            @click="handleChangeMyCompany()"
            :disabled="disableFromResponsible || !currentEdit"
            v-model="myCompanyTitle"
          />
        </div>
      </template>
    </a-form-item>

    <a-form-item :label="$t('Owner')">
      <span>{{ companyAssis }}</span>
    </a-form-item>

    <a-form-item :label="$t('Contractor')">
      <template v-if="disableFromResponsible || !currentEdit">
        {{
            getCompany(document.kontragent)
        }}
      </template>
      <template v-else>
        <span v-if="flagKontr" @click="flagKontr = !flagKontr">
          {{
             getCompany(document.kontragent)
          }}
          <i
            class="fa fa-pencil"
            style="font-size: 14px; margin-left: 15px; color: gray"
          ></i>
        </span>
        <div v-else>
          <a-input 
            @change="changePromptStatus"
            @click="handleChangeContractor()"
            :disabled="disableFromResponsible || !currentEdit"
            v-model="contactorTitle"
          />
        </div>
        <!--<a-select
          v-else
          showSearch
          optionFilterProp="children"
          v-decorator="[
            'kontragent',
            {
              rules: [
                {
                  required: true,
                  message: $t('Contractor') + $t('required_field'),
                },
              ],
              initialValue: document.kontragent,
            },
          ]"
        >
          <a-select-opt-group label="Main">
            <a-select-option v-for="(comp, id) in COMPANY_LIST" :key="id">{{
              comp.TITLE
            }}</a-select-option>
          </a-select-opt-group>
          <a-select-opt-group v-if="bounds.whole" label="OCR">
            <a-select-option v-for="item in bounds.whole.titles" :key="item">{{
              item
            }}</a-select-option>
          </a-select-opt-group>
        </a-select>-->
      </template>
    </a-form-item>

    <a-form-item :label="$t('Specialization')">
      <template v-if="disableFromResponsible || !currentEdit">
        <a-tag
          color="red"
          v-for="(item, key) in specializationInitialValue"
          :key="key"
          >{{ item }}</a-tag
        >
      </template>
      <a-select
        v-else
        showSearch
        mode="multiple"
        optionFilterProp="children"
        v-decorator="[
          'SPECJALIZACJA',
          {
            rules: [
              {
                required: true,
                message: $t('Specialization') + $t('required_field'),
              },
            ],
            initialValue: specializationInitialValue,
          },
        ]"
      >
        <a-select-opt-group label="Main">
          <a-select-option v-for="i in specialization" :key="i">{{
            i
          }}</a-select-option>
        </a-select-opt-group>
        <a-select-opt-group v-if="bounds.whole" label="OCR">
          <a-select-option v-for="item in bounds.whole.titles" :key="item">{{
            item
          }}</a-select-option>
        </a-select-opt-group>
      </a-select>
    </a-form-item>

    <a-form-item :label="$t('Tag')">
      <template v-if="disableFromResponsible || !currentEdit">
        <a-tag
          color="blue"
          v-for="(item, key) in document.TeczkaUser"
          :key="key"
          >{{ item }}</a-tag
        >
      </template>
      <a-select
        v-else
        :dropdownMatchSelectWidth="false"
        mode="tags"
        v-decorator="[
          'Teczka',
          { rules: [{ required: false }], initialValue: TeczkaUser },
        ]"
      >
        <a-select-opt-group label="Main">
          <a-select-option v-for="i in teczkalist" :key="i">{{
            i
          }}</a-select-option>
        </a-select-opt-group>
        <a-select-opt-group v-if="bounds.whole" label="OCR">
          <a-select-option v-for="item in bounds.whole.titles" :key="item">{{
            item
          }}</a-select-option>
        </a-select-opt-group>
      </a-select>
      <div>
        <a-tag color="blue" v-for="i of other_tags" :key="i">{{
          i.tagData
        }}</a-tag>
      </div>
    </a-form-item>

    <a-form-item :label="$t('Keywords')">
      <template v-if="disableFromResponsible || !currentEdit">
        <a-tag
          color="green"
          v-for="(item, key) in document.key_words"
          :key="key"
          >{{ item }}</a-tag
        >
      </template>
      <a-select
        v-else
        mode="multiple"
        v-decorator="[
          'tags',
          { rules: [{ required: false }], initialValue: document.key_words },
        ]"
      >
        <a-select-opt-group label="Main">
          <a-select-option v-for="i in key_words" :key="i">{{
            i
          }}</a-select-option>
        </a-select-opt-group>
        <a-select-opt-group v-if="bounds.whole" label="OCR">
          <a-select-option v-for="item in bounds.whole.titles" :key="item">{{
            item
          }}</a-select-option>
        </a-select-opt-group>
      </a-select>
    </a-form-item>

    <a-modal
      v-model="showFormValidationErrorModal"
      @ok="
        () => {
          showFormValidationErrorModal = false;
          ignoreErrorsAndSubmit();
        }
      "
      @cancel="
        () => {
          showFormValidationErrorModal = false;
        }
      "
      :okText="$t('Save')"
      :cancelText="$t('Close without saving')"
    >
      <p>{{ $t("mandatory_fields_r_unfilled") }}</p>
      <p>{{ $t("what_to_do") }}</p>
    </a-modal>
  </a-form>
</template>
<script>
import moment from "moment";
import { requestStep } from "@/requestFunc";

export default {
  props: [
    "document",
    "info",
    "key_words",
    "specialization",
    "COMPANY_LIST",
    "MY_COMPANY_LIST",
    "disableFromResponsible",
    "responsible",
    "profile",
    "commentsData",
    "currentEdit",
    "bounds",
    "USER_LIST"
  ],
  data() {
    return {
      form: this.$form.createForm(this, { name: "second_set" }),
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
      user_tags: [],
      other_tags: [],

      teczkalist: [],
      flagMyCompany: true,
      flagReceiving: true,
      flagComment: true,
      flagDoctype: true,
      flagDocName: true,
      flagKontr: true,
      myCompany: '',
      contractor: '',
      myCompanyTitle: '',
      contactorTitle: '',
      
      showFormValidationErrorModal: false,
    };
  },
  computed: {
    specializationInitialValue() {
      let spec = this.document.SPECJALIZACJA;
      if (spec) {
        try {
          spec = JSON.parse(spec);
          if (typeof spec == "string") throw Error;
        } catch {
          spec = [spec];
        }
        return spec;
      }
      return [];
    },
    companyAssis() {
      let comp = this.document.arrayCompany.find(
        (x) => x.ID == this.document.my_company
      ) ?? { ASSIGNED_BY_ID: -1 };
      let user = this.document.userList.find(
        (x) => x.ID == comp.ASSIGNED_BY_ID
      ) ?? {
        NAME: "",
        LAST_NAME: "",
      };
      return user.NAME + " " + user.LAST_NAME;
    },
    variblMPK: function () {
      try {
        return this.document.arrayCompany.find(
          (x) => x.ID == this.document.my_company
        ).UF_CRM_MPK_LIST;
      } catch {
        return [];
      }
    },
    TeczkaUser: function () {
      let mas = [];
      for (let i of this.user_tags) {
        mas.push(i.tagData);
      }
      return mas;
    },
  },
  methods: {
    moment,
    getUser(id) {
      let user = this.element.userList.find((x) => x.ID == id);
      return user ? user.NAME + " " + user.LAST_NAME : '';
    },
    handleMyCompanyChange() {
      this.document.my_company = this.form.getFieldValue("my_company");
      this.form.setFieldsValue({ mpk: this.variblMPK[0] });
    },
    handleChangeMyCompany() {
      // eslint-disable-next-line
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: false,
        },
        (info) => {
          this.myCompany = info.company[0].id.split("_")[1];
          this.myCompanyTitle = info.company[0].title;
        }
      );
    },
    handleChangeContractor() {
      // eslint-disable-next-line
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: false,
        },
        (info) => {
          this.contractor = info.company[0].id.split("_")[1];
          this.contactorTitle = info.company[0].title;
        }
      );
    },
    getCompany(id) {
      let company = this.document.arrayCompany.find((x) => x.ID == id);
      return company ? company.TITLE : '';
    },
    ignoreErrorsAndSubmit(comments = this.comments) {
      this.form.validateFields((err, values) => {
        this.changeSpinning();
        requestStep(this.saveValues(values, comments))
          .done((data) => {
            var res = JSON.parse(data);
            this.document.status = res.status;
            this.document.title = values.title || this.document.title;
            if (res.name) {
              this.document.NAME = res.name;
            }
            this.changeSpinning();
            if (res.status == "ZARCHIWIZOWANY") {
              this.onback(this.document.ID);
            } else {
              this.onback(this.document.ID, true);
            }
            this.$message.success(this.$t("Document Description Saved"));
          })
          .fail((e) => {
            console.err(e);
            this.$message.error(this.$t("Error describing document"));
            this.changeSpinning();
            this.onback();
          })
          .always(() => {});
      });
    },
    submit(comments) {
      this.form.validateFields((err) => {
        if (err) {
          this.showFormValidationErrorModal = true;
          this.comments = comments;
        } else {
          this.ignoreErrorsAndSubmit(comments);
        }
      });
    },
    saveValues(values, comments) {
      values.date_recept =
        values.date_recept != ""
          ? moment(values.date_recept).format("YYYY-MM-DD")
          : "";

      let data = {
        run: "savedocumentstage2",
        title: this.document.title != undefined ? this.document.title : "",
        date_recept: values.date_recept,
        num_doc: values.num_doc,
        mpk: values.mpk,
        comments: comments,
        SPECJALIZACJA: values.SPECJALIZACJA,
        ID: this.document.ID,
        name: this.document.NAME,
        kontragent: this.contractor,
        my_company: this.myCompany,
        document_type: this.document.document_type,
        arch_doc_type: this.document.arch_doc_type,
        url: this.document.url,
        proj_assist: this.responsible,
        elemid: this.document.mainid,
      };
     /* if (values.my_company) {
        data.my_company = values.my_company;
      } else {
        data.my_company = this.document.my_company;
      }
      if (values.kontragent) {
        data.kontragent = values.kontragent;
      }*/
      for (let key in values) {
        if (
          values[key] != this.document[key] &&
          typeof values[key] == typeof this.document[key]
        ) {
          data[key] = {
            old: this.document[key],
            new: values[key],
          };
          // this.document[key] = values[key];
        }
      }

      let def_tags = JSON.stringify(this.document.key_words);
      let set_tags = JSON.stringify(values.tags);
      if (def_tags != set_tags) {
        data.key_words = { old: this.document.key_words, new: values.tags };
        this.document.key_words = set_tags;
      }
      var kk = [];
      for (var i of values.Teczka) {
        kk.push({ id: this.profile["ID"], tagData: i });
      }
      data.Teczka = JSON.stringify(this.other_tags.concat(kk));

      this.document.mpk = values.mpk;
      this.document.num_doc = values.num_doc;
      this.document.Teczka = data.Teczka;
      this.document.date_recept = values.date_recept;
      this.document.SPECJALIZACJA = values.SPECJALIZACJA;
      return data;
    },
    onback(idFile, unshift_elem) {
      this.$emit("onback", {
        unshift_elem,
        remove_elem: idFile,
      });
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
  },
  mounted() {
    this.contractor = this.document.kontragent;
    this.contactorTitle = this.getCompany(this.document.kontragent);
    this.myCompany = this.document.my_company;
    this.myCompanyTitle = this.getCompany(this.document.my_company);
    this.other_tags = [];
    this.user_tags = [];
    var listtags = this.info.teczkalist;
    for (let item of this.document.Teczka) {
      if (item.id != this.profile["ID"]) {
        this.other_tags.push(item);
        let index = listtags.findIndex((x) => x == item.tagData);
        if (index != -1) {
          listtags.splice(index, 1);
        }
      } else {
        this.user_tags.push(item);
      }
    }
    this.teczkalist = listtags;

    BX24.fitWindow();
  },
};
</script>

<style scoped>
</style>